import styled from 'styled-components'

export const Container = styled.div<{ $hasAction: boolean }>`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  margin: ${({ $hasAction }) => ($hasAction ? '0 0 8px 0' : '0')};
`

export const LabelRow = styled.div<{ $hasAction: boolean }>`
  display: grid;
  grid-template-columns: ${({ $hasAction }) =>
    $hasAction ? '3fr 2fr' : '1fr'};
  justify-content: space-between;
  column-gap: 8px;
  align-items: center;
`

export const Label = styled.span`
  overflow: hidden;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`

export const ActionSlot = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const ValueArea = styled.div`
  display: flex;
  border-top: 2px solid
    ${({ theme }) => theme.colors.status?.default ?? '#abbed1'};
  padding: 4px 0;
  width: 100%;
  color: #303032;
  font-family: Barlow, sans-serif;
  font-size: 14px;
  line-height: 38px;
  cursor: default;
  overflow: hidden;

  > div {
    width: 100%;
  }
`
